import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RekapAbsenGuru = ({ token }) => {
  const todayIso = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  const monthIso = todayIso.slice(0, 7); // YYYY-MM

  // State Mode Filter: 'harian' atau 'bulanan'
  const [filterType, setFilterType] = useState('harian');
  const [tanggal, setTanggal] = useState(todayIso);
  const [bulan, setBulan] = useState(monthIso);

  const [dataGuru, setDataGuru] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleCari = async () => {
    setLoading(true);
    try {
      // Kirim parameter tanggal (harian) ATAU bulan (bulanan) ke API
      const params = filterType === 'harian' ? { tanggal } : { bulan };

      const res = await axios.get(`/api/absen-guru?_t=${new Date().getTime()}`, {
        params,
        headers: { Authorization: `Bearer ${token}` }
      });
      setDataGuru(Array.isArray(res.data) ? res.data : []);
    } catch (err) { 
      console.error(err);
      alert('Gagal memuat data rekap guru'); 
    }
    setLoading(false);
  };

  useEffect(() => { 
    handleCari(); 
  }, [filterType]); // Auto-fetch saat ganti mode harian/bulanan

  // Format Tanggal dengan Nama Hari (Contoh: Kamis, 6 Agu 2026)
  const formatHariTanggal = (isoDate) => {
    if (!isoDate) return '-';
    const date = new Date(isoDate);
    return date.toLocaleDateString('id-ID', { 
      weekday: 'long', 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  // Helper Style Status Badge
  const getStatusBadgeStyle = (status) => {
    const st = (status || '').toLowerCase();
    switch (st) {
      case 'hadir':
        return { color: '#15803d', background: '#dcfce7', label: 'Hadir' };
      case 'telat':
        return { color: '#b45309', background: '#fef3c7', label: 'Telat' };
      case 'izin':
        return { color: '#1d4ed8', background: '#dbeafe', label: 'Izin' };
      case 'sakit':
        return { color: '#6d28d9', background: '#f3e8ff', label: 'Sakit' };
      case 'dinas_luar':
      case 'dinas luar':
      case 'dl':
        return { color: '#0369a1', background: '#e0f2fe', label: 'Dinas Luar' };
      default:
        return { color: '#991b1b', background: '#fee2e2', label: status ? status.toUpperCase() : 'Alfa' };
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      
      {/* NO PRINT FILTER HEADER */}
      <div className="no-print" style={{ marginBottom: '20px' }}>
        <h2 style={{ color: '#1e293b', marginBottom: '15px' }}>👨‍🏫 Laporan Kehadiran Guru</h2>
        
        <div style={{ display: 'flex', gap: '15px', background: 'white', padding: '15px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', alignItems: 'center', flexWrap: 'wrap' }}>
          
          {/* TOGGLE HARIAN / BULANAN */}
          <div style={{ background: '#f1f5f9', padding: '4px', borderRadius: '8px', display: 'flex', gap: '4px' }}>
            <button
              onClick={() => setFilterType('harian')}
              style={{
                padding: '6px 14px',
                borderRadius: '6px',
                border: 'none',
                background: filterType === 'harian' ? '#4361ee' : 'transparent',
                color: filterType === 'harian' ? 'white' : '#64748b',
                fontWeight: 'bold',
                fontSize: '13px',
                cursor: 'pointer'
              }}
            >
              📅 Harian
            </button>
            <button
              onClick={() => setFilterType('bulanan')}
              style={{
                padding: '6px 14px',
                borderRadius: '6px',
                border: 'none',
                background: filterType === 'bulanan' ? '#4361ee' : 'transparent',
                color: filterType === 'bulanan' ? 'white' : '#64748b',
                fontWeight: 'bold',
                fontSize: '13px',
                cursor: 'pointer'
              }}
            >
              📆 Bulanan
            </button>
          </div>

          {/* INPUT TANGGAL ATAU BULAN */}
          {filterType === 'harian' ? (
            <input 
              type="date" 
              value={tanggal} 
              onChange={e => setTanggal(e.target.value)} 
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }} 
            />
          ) : (
            <input 
              type="month" 
              value={bulan} 
              onChange={e => setBulan(e.target.value)} 
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }} 
            />
          )}

          <button 
            onClick={handleCari} 
            style={{ background: '#4361ee', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}
          >
            🔍 Tampilkan
          </button>
          
          <button 
            onClick={() => window.print()} 
            style={{ background: '#334155', color: 'white', padding: '8px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}
          >
            🖨️ Cetak PDF
          </button>

        </div>
      </div>

      {/* PRINT AREA */}
      <div className="print-area" style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <div style={{ textAlign: 'center', marginBottom: '25px', borderBottom: '2px solid #1e293b', paddingBottom: '15px' }}>
          <h3 style={{ margin: '0 0 5px', color: '#1e293b', fontSize: '20px' }}>
            LAPORAN KEHADIRAN GURU & STAFF ({filterType === 'harian' ? 'HARIAN' : 'BULANAN'})
          </h3>
          <p style={{ margin: 0, color: '#64748b' }}>
            Periode: <b>{filterType === 'harian' ? formatHariTanggal(tanggal) : bulan}</b>
          </p>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', padding: '30px', color: '#64748b' }}>Memuat rekap data...</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }} border="1" borderColor="#e2e8f0">
            <thead>
              <tr style={{ background: '#f8fafc', color: '#334155' }}>
                <th style={{ padding: '10px', width: '40px' }}>No</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Hari & Tanggal</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Nama Guru / Staff</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>NIP</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Mapel</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Kelas</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Jam Mengajar</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Jam Absen</th>
                <th style={{ padding: '10px', textAlign: 'center' }}>Status</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>Keterangan</th>
              </tr>
            </thead>
            <tbody>
              {dataGuru.length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: 'center', padding: '30px', color: '#94a3b8', fontStyle: 'italic' }}>
                    Tidak ada data kehadiran guru pada {filterType === 'harian' ? 'tanggal' : 'bulan'} ini.
                  </td>
                </tr>
              ) : (
                dataGuru.map((d, idx) => {
                  const badgeStyle = getStatusBadgeStyle(d.status);
                  return (
                    <tr key={idx} style={{ background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                      <td style={{ textAlign: 'center', padding: '10px' }}>{idx + 1}</td>
                      
                      {/* HARI & TANGGAL */}
                      <td style={{ padding: '10px', fontWeight: 'bold', color: '#1e293b', whiteSpace: 'nowrap' }}>
                        {formatHariTanggal(d.tanggal)}
                      </td>

                      {/* NAMA GURU */}
                      <td style={{ padding: '10px', fontWeight: 'bold', color: '#1e293b' }}>
                        {d.nama_guru || d.nama}
                      </td>

                      {/* NIP */}
                      <td style={{ padding: '10px', color: '#64748b' }}>
                        {d.nip || '-'}
                      </td>

                      {/* MAPEL */}
                      <td style={{ padding: '10px', fontWeight: '600', color: '#2563eb' }}>
                        {d.mapel || 'Piket / Pengayaan'}
                      </td>

                      {/* KELAS */}
                      <td style={{ textAlign: 'center', padding: '10px' }}>
                        {d.nama_kelas && d.nama_kelas !== '-' ? (
                          <span style={{ fontSize: '11px', background: '#dbeafe', color: '#1e40af', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
                            🏫 {d.nama_kelas}
                          </span>
                        ) : (
                          <span style={{ color: '#94a3b8' }}>-</span>
                        )}
                      </td>

                      {/* JAM MENGAJAR */}
                      <td style={{ textAlign: 'center', padding: '10px', fontWeight: 'bold', color: '#475569' }}>
                        {d.jam_mengajar || '-'}
                      </td>

                      {/* JAM ABSEN */}
                      <td style={{ textAlign: 'center', padding: '10px', color: '#64748b' }}>
                        {d.jam_masuk ? `${d.jam_masuk.slice(0, 5)} WIB` : '-'}
                      </td>

                      {/* STATUS */}
                      <td style={{ textAlign: 'center', padding: '10px' }}>
                        <span style={{ 
                          padding: '4px 8px', 
                          borderRadius: '6px', 
                          fontSize: '11px', 
                          fontWeight: 'bold', 
                          textTransform: 'uppercase',
                          color: badgeStyle.color,
                          background: badgeStyle.background
                        }}>
                          {badgeStyle.label}
                        </span>
                      </td>

                      {/* KETERANGAN */}
                      <td style={{ padding: '10px', color: '#64748b' }}>
                        {d.keterangan || '-'}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}

        {/* TANDA TANGAN KEPALA SEKOLAH */}
        <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ textAlign: 'center', width: '220px' }}>
            <p style={{ margin: '0 0 60px' }}>Kepala Sekolah,</p>
            <p style={{ margin: 0, fontWeight: 'bold' }}>( __________________ )</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RekapAbsenGuru;